import { render } from "./EvalvationAI.vue?vue&type=template&id=15839cb8"
import script from "./EvalvationAI.vue?vue&type=script&lang=js"
export * from "./EvalvationAI.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__